import { render, staticRenderFns } from "./CategoryPageContent.vue?vue&type=template&id=14c4c6a4&scoped=true&"
import script from "./CategoryPageContent.vue?vue&type=script&lang=js&"
export * from "./CategoryPageContent.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPageContent.vue?vue&type=style&index=0&id=14c4c6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4c6a4",
  null
  
)

export default component.exports